import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type BenefitRestrictionFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const BenefitRestrictionFilled = forwardRef<SVGSVGElement, BenefitRestrictionFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(0.5 0.5) scale(0.71875)">
        <path d="M16.0001 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5818 24 16.0001 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16.0001 8ZM15.6146 23.1148C11.8981 23.1148 8.88515 20.102 8.88515 16.3855H15.6146V23.1148ZM15.6146 15.6146H8.88515C8.88515 11.898 11.8981 8.88515 15.6146 8.88515V15.6146ZM16.3854 23.1148V16.3855H23.1148C23.1148 20.102 20.1019 23.1148 16.3854 23.1148ZM16.3854 15.6146V8.88515C20.1019 8.88515 23.1148 11.898 23.1148 15.6146H16.3854Z" />
        <path d="M16 0C7.16341 0 0 7.16345 0 16C0 24.8366 7.16341 32 16 32C24.8365 32 32 24.8366 32 16C32 7.16345 24.8365 0 16 0ZM16 24.9136C11.077 24.9136 7.08639 20.9228 7.08639 16C7.08639 11.0772 11.0771 7.08651 16 7.08651C20.9227 7.08651 24.9135 11.0772 24.9135 16C24.9135 20.9228 20.9227 24.9136 16 24.9136Z" />
      </g>
    </svg>
  ),
);

BenefitRestrictionFilled.displayName = 'BenefitRestrictionFilled';

export default BenefitRestrictionFilled;
